import { configureStore as configureStoreToolkit, Store } from '@reduxjs/toolkit';
import { routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import { createRootReducer, rootSaga } from 'state/ducks';
import { sagaMiddleware } from 'state/middlewares';

export const history = createBrowserHistory();

export const rootReducer = createRootReducer(history);

export type ApplicationState = ReturnType<typeof rootReducer>;

export default function configureStore(initialState?: Partial<ApplicationState>): Store<ApplicationState> {
    const store = configureStoreToolkit({
        preloadedState: initialState,
        reducer: rootReducer,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({ serializableCheck: false })
                .concat(routerMiddleware(history))
                .concat(sagaMiddleware),
        devTools: process.env.NODE_ENV !== 'production',
    });

    sagaMiddleware.run(rootSaga);

    return store;
}